jQuery(document).ready(function($){
    if ( $('.nf-insights-slider') ) {
        $('.nf-insights-slider .nf-insights-slider__wrapper').slick({
            slidesToScroll: 1,
            slidesToShow: 2,
            prevArrow: '',
            nextArrow: '<button><svg width="63" height="46" viewBox="0 0 63 46" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M62.1213 25.1213C63.2929 23.9497 63.2929 22.0502 62.1213 20.8787L43.0294 1.78679C41.8579 0.615219 39.9584 0.615219 38.7868 1.78679C37.6152 2.95837 37.6152 4.85786 38.7868 6.02943L55.7574 23L38.7868 39.9706C37.6152 41.1421 37.6152 43.0416 38.7868 44.2132C39.9584 45.3848 41.8579 45.3848 43.0294 44.2132L62.1213 25.1213ZM2.62268e-07 26L60 26L60 20L-2.62268e-07 20L2.62268e-07 26Z" fill="#FF551F"/></svg></button>',
            appendArrows: $('.nf-insights-slider__nav'),
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 993,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                        fade: true,
                    }
                }
            ]
        });
    }
});